import { LogOut } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Header({ user, editLoan, loanNumber }) {
  const location = useLocation();
  const navigate = useNavigate();

  const getPageTitle = () => {
    // Check if we're in edit mode and have a loan number
    if (editLoan && loanNumber) {
      return `Edit Loan - #${loanNumber}`;
    }
    
    switch (location.pathname) {
      case '/':
        return 'Loan Details';
      case '/loans':
        return 'Loan Details';
      case '/form':
        return 'Create New Loan';
      case '/dashboard':
        return 'Dashboard';
      case '/interest':
        return 'Interest Payments';
      default:
        return 'Vinayaga Gold Finance';
    }
  };

  const handleLogout = () => {
    // Clear all stored data
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userData');
    
    // Navigate to login page
    navigate('/login');
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        {/* Left Side with Page Title */}
        <div className="flex items-center space-x-4">
          <div>
            <h1 className="text-xl font-bold text-indigo-900">
              {getPageTitle()}
            </h1>
          </div>
        </div>

        {/* Right Side with User Info */}
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-3">
            <div className="text-right">
              <div className="text-sm font-medium text-gray-900">{user.name}</div>
            </div>
            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-500 rounded-full flex items-center justify-center">
              <span className="text-white text-sm font-medium">{user.name.charAt(0)}</span>
            </div>
            {/* Logout Button */}
            <button 
              onClick={handleLogout}
              className="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              title="Logout"
            >
              <LogOut size={20} />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}